import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll } from "framer-motion";
import "@/App.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Gallery } from "@/components/site/Gallery";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Cursor } from "@/components/site/Cursor";

function App() {
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-brand-black text-white">
      <motion.div
        data-testid="scroll-progress"
        style={{ scaleX: scrollYProgress }}
        className="fixed top-0 left-0 right-0 h-[3px] bg-brand-red origin-left z-[70]"
      />
      <Cursor />
      <div className="grain" aria-hidden="true" />
      <Toaster position="top-center" theme="dark" richColors />
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Manifesto />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
